const cphones = [
  { label: "AD", code: "Andorra", value: "376" },
  {
    label: "AE",
    code: "United Arab Emirates",
    value: "971",
  },
  { label: "AF", code: "Afghanistan", value: "93" },
  {
    label: "AG",
    code: "Antigua and Barbuda",
    value: "1-268",
  },
  { label: "AI", code: "Anguilla", value: "1-264" },
  { label: "AL", code: "Albania", value: "355" },
  { label: "AM", code: "Armenia", value: "374" },
  { label: "AO", code: "Angola", value: "244" },
  { label: "AQ", code: "Antarctica", value: "672" },
  { label: "AR", code: "Argentina", value: "54" },
  { label: "AS", code: "American Samoa", value: "1-684" },
  { label: "AT", code: "Austria", value: "43" },
  {
    label: "AU",
    code: "Australia",
    value: "61",
    suggested: true,
  },
  { label: "AW", code: "Aruba", value: "297" },
  { label: "AX", code: "Alland Islands", value: "358" },
  { label: "AZ", code: "Azerbaijan", value: "994" },
  {
    label: "BA",
    code: "Bosnia and Herzegovina",
    value: "387",
  },
  { label: "BB", code: "Barbados", value: "1-246" },
  { label: "BD", code: "Bangladesh", value: "880" },
  { label: "BE", code: "Belgium", value: "32" },
  { label: "BF", code: "Burkina Faso", value: "226" },
  { label: "BG", code: "Bulgaria", value: "359" },
  { label: "BH", code: "Bahrain", value: "973" },
  { label: "BI", code: "Burundi", value: "257" },
  { label: "BJ", code: "Benin", value: "229" },
  { label: "BL", code: "Saint Barthelemy", value: "590" },
  { label: "BM", code: "Bermuda", value: "1-441" },
  { label: "BN", code: "Brunei Darussalam", value: "673" },
  { label: "BO", code: "Bolivia", value: "591" },
  { label: "BR", code: "Brazil", value: "55" },
  { label: "BS", code: "Bahamas", value: "1-242" },
  { label: "BT", code: "Bhutan", value: "975" },
  { label: "BV", code: "Bouvet Island", value: "47" },
  { label: "BW", code: "Botswana", value: "267" },
  { label: "BY", code: "Belarus", value: "375" },
  { label: "BZ", code: "Belize", value: "501" },
  {
    label: "CA",
    code: "Canada",
    value: "1",
    suggested: true,
  },
  {
    label: "CC",
    code: "Cocos (Keeling) Islands",
    value: "61",
  },
  {
    label: "CD",
    code: "Congo, Democratic Republic of the",
    value: "243",
  },
  {
    label: "CF",
    code: "Central African Republic",
    value: "236",
  },
  {
    label: "CG",
    code: "Congo, Republic of the",
    value: "242",
  },
  { label: "CH", code: "Switzerland", value: "41" },
  { label: "CI", code: "Cote d'Ivoire", value: "225" },
  { label: "CK", code: "Cook Islands", value: "682" },
  { label: "CL", code: "Chile", value: "56" },
  { label: "CM", code: "Cameroon", value: "237" },
  { label: "CN", code: "China", value: "86" },
  { label: "CO", code: "Colombia", value: "57" },
  { label: "CR", code: "Costa Rica", value: "506" },
  { label: "CU", code: "Cuba", value: "53" },
  { label: "CV", code: "Cape Verde", value: "238" },
  { label: "CW", code: "Curacao", value: "599" },
  { label: "CX", code: "Christmas Island", value: "61" },
  { label: "CY", code: "Cyprus", value: "357" },
  { label: "CZ", code: "Czech Republic", value: "420" },
  {
    label: "DE",
    code: "Germany",
    value: "49",
    suggested: true,
  },
  { label: "DJ", code: "Djibouti", value: "253" },
  { label: "DK", code: "Denmark", value: "45" },
  { label: "DM", code: "Dominica", value: "1-767" },
  {
    label: "DO",
    code: "Dominican Republic",
    value: "1-809",
  },
  { label: "DZ", code: "Algeria", value: "213" },
  { label: "EC", code: "Ecuador", value: "593" },
  { label: "EE", code: "Estonia", value: "372" },
  { label: "EG", code: "Egypt", value: "20" },
  { label: "EH", code: "Western Sahara", value: "212" },
  { label: "ER", code: "Eritrea", value: "291" },
  { label: "ES", code: "Spain", value: "34" },
  { label: "ET", code: "Ethiopia", value: "251" },
  { label: "FI", code: "Finland", value: "358" },
  { label: "FJ", code: "Fiji", value: "679" },
  {
    label: "FK",
    code: "Falkland Islands (Malvinas)",
    value: "500",
  },
  {
    label: "FM",
    code: "Micronesia, Federated States of",
    value: "691",
  },
  { label: "FO", code: "Faroe Islands", value: "298" },
  {
    label: "FR",
    code: "France",
    value: "33",
    suggested: true,
  },
  { label: "GA", code: "Gabon", value: "241" },
  { label: "GB", code: "United Kingdom", value: "44" },
  { label: "GD", code: "Grenada", value: "1-473" },
  { label: "GE", code: "Georgia", value: "995" },
  { label: "GF", code: "French Guiana", value: "594" },
  { label: "GG", code: "Guernsey", value: "44" },
  { label: "GH", code: "Ghana", value: "233" },
  { label: "GI", code: "Gibraltar", value: "350" },
  { label: "GL", code: "Greenland", value: "299" },
  { label: "GM", code: "Gambia", value: "220" },
  { label: "GN", code: "Guinea", value: "224" },
  { label: "GP", code: "Guadeloupe", value: "590" },
  { label: "GQ", code: "Equatorial Guinea", value: "240" },
  { label: "GR", code: "Greece", value: "30" },
  {
    label: "GS",
    code: "South Georgia and the South Sandwich Islands",
    value: "500",
  },
  { label: "GT", code: "Guatemala", value: "502" },
  { label: "GU", code: "Guam", value: "1-671" },
  { label: "GW", code: "Guinea-Bissau", value: "245" },
  { label: "GY", code: "Guyana", value: "592" },
  { label: "HK", code: "Hong Kong", value: "852" },
  {
    label: "HM",
    code: "Heard Island and McDonald Islands",
    value: "672",
  },
  { label: "HN", code: "Honduras", value: "504" },
  { label: "HR", code: "Croatia", value: "385" },
  { label: "HT", code: "Haiti", value: "509" },
  { label: "HU", code: "Hungary", value: "36" },
  { label: "ID", code: "Indonesia", value: "62" },
  { label: "IE", code: "Ireland", value: "353" },
  { label: "IL", code: "Israel", value: "972" },
  { label: "IM", code: "Isle of Man", value: "44" },
  { label: "IN", code: "India", value: "91" },
  {
    label: "IO",
    code: "British Indian Ocean Territory",
    value: "246",
  },
  { label: "IQ", code: "Iraq", value: "964" },
  {
    label: "IR",
    code: "Iran, Islamic Republic of",
    value: "98",
  },
  { label: "IS", code: "Iceland", value: "354" },
  { label: "IT", code: "Italy", value: "39" },
  { label: "JE", code: "Jersey", value: "44" },
  { label: "JM", code: "Jamaica", value: "1-876" },
  { label: "JO", code: "Jordan", value: "962" },
  {
    label: "JP",
    code: "Japan",
    value: "81",
    suggested: true,
  },
  { label: "KE", code: "Kenya", value: "254" },
  { label: "KG", code: "Kyrgyzstan", value: "996" },
  { label: "KH", code: "Cambodia", value: "855" },
  { label: "KI", code: "Kiribati", value: "686" },
  { label: "KM", code: "Comoros", value: "269" },
  {
    label: "KN",
    code: "Saint Kitts and Nevis",
    value: "1-869",
  },
  {
    label: "KP",
    code: "Korea, Democratic People's Republic of",
    value: "850",
  },
  { label: "KR", code: "Korea, Republic of", value: "82" },
  { label: "KW", code: "Kuwait", value: "965" },
  { label: "KY", code: "Cayman Islands", value: "1-345" },
  { label: "KZ", code: "Kazakhstan", value: "7" },
  {
    label: "LA",
    code: "Lao People's Democratic Republic",
    value: "856",
  },
  { label: "LB", code: "Lebanon", value: "961" },
  { label: "LC", code: "Saint Lucia", value: "1-758" },
  { label: "LI", code: "Liechtenstein", value: "423" },
  { label: "LK", code: "Sri Lanka", value: "94" },
  { label: "LR", code: "Liberia", value: "231" },
  { label: "LS", code: "Lesotho", value: "266" },
  { label: "LT", code: "Lithuania", value: "370" },
  { label: "LU", code: "Luxembourg", value: "352" },
  { label: "LV", code: "Latvia", value: "371" },
  { label: "LY", code: "Libya", value: "218" },
  { label: "MA", code: "Morocco", value: "212" },
  { label: "MC", code: "Monaco", value: "377" },
  {
    label: "MD",
    code: "Moldova, Republic of",
    value: "373",
  },
  { label: "ME", code: "Montenegro", value: "382" },
  {
    label: "MF",
    code: "Saint Martin (French part)",
    value: "590",
  },
  { label: "MG", code: "Madagascar", value: "261" },
  { label: "MH", code: "Marshall Islands", value: "692" },
  {
    label: "MK",
    code: "Macedonia, the Former Yugoslav Republic of",
    value: "389",
  },
  { label: "ML", code: "Mali", value: "223" },
  { label: "MM", code: "Myanmar", value: "95" },
  { label: "MN", code: "Mongolia", value: "976" },
  { label: "MO", code: "Macao", value: "853" },
  {
    label: "MP",
    code: "Northern Mariana Islands",
    value: "1-670",
  },
  { label: "MQ", code: "Martinique", value: "596" },
  { label: "MR", code: "Mauritania", value: "222" },
  { label: "MS", code: "Montserrat", value: "1-664" },
  { label: "MT", code: "Malta", value: "356" },
  { label: "MU", code: "Mauritius", value: "230" },
  { label: "MV", code: "Maldives", value: "960" },
  { label: "MW", code: "Malawi", value: "265" },
  { label: "MX", code: "Mexico", value: "52" },
  { label: "MY", code: "Malaysia", value: "60" },
  { label: "MZ", code: "Mozambique", value: "258" },
  { label: "NA", code: "Namibia", value: "264" },
  { label: "NC", code: "New Caledonia", value: "687" },
  { label: "NE", code: "Niger", value: "227" },
  { label: "NF", code: "Norfolk Island", value: "672" },
  { label: "NG", code: "Nigeria", value: "234" },
  { label: "NI", code: "Nicaragua", value: "505" },
  { label: "NL", code: "Netherlands", value: "31" },
  { label: "NO", code: "Norway", value: "47" },
  { label: "NP", code: "Nepal", value: "977" },
  { label: "NR", code: "Nauru", value: "674" },
  { label: "NU", code: "Niue", value: "683" },
  { label: "NZ", code: "New Zealand", value: "64" },
  { label: "OM", code: "Oman", value: "968" },
  { label: "PA", code: "Panama", value: "507" },
  { label: "PE", code: "Peru", value: "51" },
  { label: "PF", code: "French Polynesia", value: "689" },
  { label: "PG", code: "Papua New Guinea", value: "675" },
  { label: "PH", code: "Philippines", value: "63" },
  { label: "PK", code: "Pakistan", value: "92" },
  { label: "PL", code: "Poland", value: "48" },
  {
    label: "PM",
    code: "Saint Pierre and Miquelon",
    value: "508",
  },
  { label: "PN", code: "Pitcairn", value: "870" },
  { label: "PR", code: "Puerto Rico", value: "1" },
  {
    label: "PS",
    code: "Palestine, State of",
    value: "970",
  },
  { label: "PT", code: "Portugal", value: "351" },
  { label: "PW", code: "Palau", value: "680" },
  { label: "PY", code: "Paraguay", value: "595" },
  { label: "QA", code: "Qatar", value: "974" },
  { label: "RE", code: "Reunion", value: "262" },
  { label: "RO", code: "Romania", value: "40" },
  { label: "RS", code: "Serbia", value: "381" },
  { label: "RU", code: "Russian Federation", value: "7" },
  { label: "RW", code: "Rwanda", value: "250" },
  { label: "SA", code: "Saudi Arabia", value: "966" },
  { label: "SB", code: "Solomon Islands", value: "677" },
  { label: "SC", code: "Seychelles", value: "248" },
  { label: "SD", code: "Sudan", value: "249" },
  { label: "SE", code: "Sweden", value: "46" },
  { label: "SG", code: "Singapore", value: "65" },
  { label: "SH", code: "Saint Helena", value: "290" },
  { label: "SI", code: "Slovenia", value: "386" },
  {
    label: "SJ",
    code: "Svalbard and Jan Mayen",
    value: "47",
  },
  { label: "SK", code: "Slovakia", value: "421" },
  { label: "SL", code: "Sierra Leone", value: "232" },
  { label: "SM", code: "San Marino", value: "378" },
  { label: "SN", code: "Senegal", value: "221" },
  { label: "SO", code: "Somalia", value: "252" },
  { label: "SR", code: "Suriname", value: "597" },
  { label: "SS", code: "South Sudan", value: "211" },
  {
    label: "ST",
    code: "Sao Tome and Principe",
    value: "239",
  },
  { label: "SV", code: "El Salvador", value: "503" },
  {
    label: "SX",
    code: "Sint Maarten (Dutch part)",
    value: "1-721",
  },
  {
    label: "SY",
    code: "Syrian Arab Republic",
    value: "963",
  },
  { label: "SZ", code: "Swaziland", value: "268" },
  {
    label: "TC",
    code: "Turks and Caicos Islands",
    value: "1-649",
  },
  { label: "TD", code: "Chad", value: "235" },
  {
    label: "TF",
    code: "French Southern Territories",
    value: "262",
  },
  { label: "TG", code: "Togo", value: "228" },
  { label: "TH", code: "Thailand", value: "66" },
  { label: "TJ", code: "Tajikistan", value: "992" },
  { label: "TK", code: "Tokelau", value: "690" },
  { label: "TL", code: "Timor-Leste", value: "670" },
  { label: "TM", code: "Turkmenistan", value: "993" },
  { label: "TN", code: "Tunisia", value: "216" },
  { label: "TO", code: "Tonga", value: "676" },
  { label: "TR", code: "Turkey", value: "90" },
  {
    label: "TT",
    code: "Trinidad and Tobago",
    value: "1-868",
  },
  { label: "TV", code: "Tuvalu", value: "688" },
  {
    label: "TW",
    code: "Taiwan, Republic of China",
    value: "886",
  },
  {
    label: "TZ",
    code: "United Republic of Tanzania",
    value: "255",
  },
  { label: "UA", code: "Ukraine", value: "380" },
  { label: "UG", code: "Uganda", value: "256" },
  {
    label: "US",
    code: "United States",
    value: "1",
    suggested: true,
  },
  { label: "UY", code: "Uruguay", value: "598" },
  { label: "UZ", code: "Uzbekistan", value: "998" },
  {
    label: "VA",
    code: "Holy See (Vatican City State)",
    value: "379",
  },
  {
    label: "VC",
    code: "Saint Vincent and the Grenadines",
    value: "1-784",
  },
  { label: "VE", code: "Venezuela", value: "58" },
  {
    label: "VG",
    code: "British Virgin Islands",
    value: "1-284",
  },
  {
    label: "VI",
    code: "US Virgin Islands",
    value: "1-340",
  },
  { label: "VN", code: "Vietnam", value: "84" },
  { label: "VU", code: "Vanuatu", value: "678" },
  { label: "WF", code: "Wallis and Futuna", value: "681" },
  { label: "WS", code: "Samoa", value: "685" },
  { label: "XK", code: "Kosovo", value: "383" },
  { label: "YE", code: "Yemen", value: "967" },
  { label: "YT", code: "Mayotte", value: "262" },
  { label: "ZA", code: "South Africa", value: "27" },
  { label: "ZM", code: "Zambia", value: "260" },
  { label: "ZW", code: "Zimbabwe", value: "263" },
];

export default cphones;
